import { render } from "./kitchensink-modal.html?vue&type=template&id=fa0af186&scoped=true&ts=true&external"
import script from "./kitchensink-modal.ts?vue&type=script&lang=ts&external"
export * from "./kitchensink-modal.ts?vue&type=script&lang=ts&external"

import "./kitchensink-modal.scss?vue&type=style&index=0&id=fa0af186&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa0af186"]])

export default __exports__